import React, { useMemo } from "react";
import { useGameState } from "context/GameContext";
import {
  Abilities,
  RoundState,
  VetoState,
  VoteState,
} from "context/interfaces/GameContextInterface";
// Comps
import VotingGovernment from "./components/VotingGovernment/VotingGovernment";
import LegislativeSession from "./components/LegislativeSession/LegislativeSession";
import RevealAbility from "./components/RevealAbility/RevealAbility";
import SearchAbility from "./components/SearchAbility/SearchAbility";
import RestartGame from "./components/RestartGame/RestartGame";
import Veto from "./components/Veto/Veto";
// Css
import classes from "./Modal.module.scss";

const Modal: React.FC = () => {
  const {
    roundState,
    activeAbility,
    requestRestart,
    player,
    isPresidentIndex,
    isChancellorIndex,
    vetoState,
    chosenPlayerIndex,
  } = useGameState();

  const isShowModal = useMemo(() => {
    if (requestRestart) return true;
    switch (roundState) {
      case RoundState.votingGovernment:
        return !player.isDead && player.voteState === VoteState.None;
      case RoundState.PresidentRule:
        return player.id === isPresidentIndex;
      case RoundState.ChancellorRule:
        return (
          (player.id === isChancellorIndex &&
            vetoState !== VetoState.Request) ||
          (player.id === isPresidentIndex && vetoState === VetoState.Request)
        );
      case RoundState.AbilityActive:
        return (
          (player.id === isPresidentIndex &&
            activeAbility !== Abilities.Kill &&
            activeAbility !== Abilities.NextPresident &&
            activeAbility !== Abilities.Search) ||
          (chosenPlayerIndex &&
            activeAbility === Abilities.Search &&
            player.id === isPresidentIndex)
        );
      default:
        return false;
    }
  }, [
    requestRestart,
    roundState,
    player.isDead,
    player.voteState,
    player.id,
    isPresidentIndex,
    isChancellorIndex,
    vetoState,
    activeAbility,
    chosenPlayerIndex,
  ]);

  return (
    <>
      {isShowModal && (
        <div className={classes.layer}>
          <div className={classes.container}>
            {roundState === RoundState.votingGovernment && <VotingGovernment />}
            {roundState === RoundState.PresidentRule && <LegislativeSession />}
            {roundState === RoundState.ChancellorRule &&
              player.id === isChancellorIndex &&
              vetoState !== VetoState.Request && <LegislativeSession />}
            {roundState === RoundState.AbilityActive &&
              activeAbility === Abilities.Reveal && <RevealAbility />}
            {roundState === RoundState.AbilityActive &&
              activeAbility === Abilities.Search &&
              chosenPlayerIndex &&
              player.id === isPresidentIndex && <SearchAbility />}
            {requestRestart && <RestartGame />}
            {roundState === RoundState.ChancellorRule &&
              player.id === isPresidentIndex &&
              vetoState === VetoState.Request && <Veto />}
          </div>
        </div>
      )}
    </>
  );
};

export default Modal;
